import React from 'react';
import Button from './UI/Button';

const MobileComponent = () => {
    const styles = {
        container: {
            textAlign: 'center',
            padding: '20px',
            display: 'flex',
            height: '100vh',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '600px',
            margin: '0 auto',
        },
        logo: {
            width: '265px',
            height: 'auto',
            margin: '70px 100px',
        },
        title: {
            fontSize: '30px',
            fontWeight: 'bold',
            margin: 'auto 0px 20px 0px',
        },
        paragraph: {
            fontSize: '16px',
            marginBottom: '40px',
        },
        button: {
           margin: '0px 0px auto 0px'
        }
    };

    return (
        <div style={styles.container}>
            <img src={require('../assets/images/logo-black.png')} alt="logo" style={styles.logo} />
            <h1 style={styles.title}>Dashboard Unavailable on Mobile</h1>
            <p style={styles.paragraph}>Our dashboard is currently designed for larger screens. We’re actively working on a mobile-friendly version—stay tuned! For now, please access it from a desktop to login.</p>
            <Button text="Back to website" wrapperStyles={styles.button} onClick={() => window.location.href = "https://www.echoagent.io"} />
        </div>
    );
};

export default MobileComponent;